






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import fetch from '@/common/api/fetch';
import CONFIG from '@/common/config';

import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import appSuccess from '@/common/utils/appSuccess';
import { formatMoney } from '@/common/utils/format';
import { isXiaomaiApp, isMobile } from '@/common/utils/getPlaform';
import validForm from '@/common/utils/validForm';
import dealRouterPath from '@/common/filters/dealRoutePath';

import { AxiosPromiseData, State } from '@/common/interface';
import { Ladder } from '@/common/interface/group_type';

import MaterialModal from '@/components/common/index/MaterialModal.vue';
import DistributeConfirmModal from '@/pages/distributeType/components/edit/DistributeConfirmModal.vue';
import DistributeGroupConfirmModal from '@/pages/distributeGroupType/components/edit/DistributeConfirmModal.vue';
const HIGHLIGHT_COLOR = '#FF6152';

@Component({
  components: {
    'material-modal': MaterialModal,
    'distribute-confirm-modal': DistributeConfirmModal,
    'distribute-group-confirm-modal': DistributeGroupConfirmModal
  }
})
export default class EditFooter extends Vue {
  @Prop() save!: Function;
  @Prop() cancle!: Function;

  @Getter('instId') instId!: string;
  @Getter('instIds') instIds!: Array<string>;
  @Getter('gradientColor') gradientColor!: string;
  @Getter('deadline') deadline!: string;
  @Getter('startTime') startTime!: string;
  @Getter('mainTextColor') mainTextColor!: string;
  @Getter('title') title!: string;
  @Getter('isLimited') isLimited!: string;
  @Getter('limitNum') limitNum!: number;
  @Getter('selectedBGM') selectedBGM!: object;
  @Getter('instPhone') instPhone!: string;
  @Getter('courseType') courseType!: string;
  @Getter('courseGroupList') courseGroupList!: any;

  // @Getter("activityRule") activityRule!: string;
  @Getter('activityTitle') activityTitle!: string;
  @Getter('activityIntros') activityIntros!: Array<object>;
  @Getter('activitySwitch') activitySwitch!: boolean;

  @Getter('contactTitle') contactTitle!: string;
  @Getter('contactInfo') contactInfo!: string;
  @Getter('contactSwitch') contactSwitch!: boolean;

  @Getter('institutionIntros') institutionIntros!: Array<object>;
  @Getter('institutionSwitch') institutionSwitch!: boolean;
  @Getter('institutionTitle') institutionTitle!: string;

  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('limitFlag') limitFlag!: boolean;
  @Getter('limitFlagNumber') limitFlagNumber!: number;
  @Getter('canPay') canPay!: boolean;
  @Getter('payType') payType!: string;
  @Getter('payNumber') payNumber!: number;
  @Getter('showFooter') showFooter!: boolean;
  @Getter('titleSection') titleSection!: any;
  @Getter('documentTitle') documentTitle!: string;
  @Getter('mustMinPay') mustMinPay!: boolean;
  @Getter('virtualGroup') virtualGroup!: boolean;
  @Getter('hasMaterialSaved') hasMaterialSaved!: boolean;
  @Getter('hasOpenSMSVerify') hasOpenSMSVerify!: boolean;

  @Action('changeSectionCourseType') changeSectionCourseType!: Function;

  test: boolean = false; // 本地调试

  templateType: string = getActivityType();
  showMaterial: boolean = false;
  currentId: string = '';
  type: string = getUrlParam('type') as string;
  showConfirmModal: boolean = false;
  showDistriubteGroupConfirmModal: boolean = false;

  // 切换页面
  handleChangeView(): void {
    const source: string = getUrlParam('source') as string;
    const activityType: string = getActivityType() as string;
    if (this.type === 'edit' || this.type === 'reEdit') {
      this.$router.push({
        path: dealRouterPath('/' + activityType + '/index', 'preview')
      });
    } else if (this.type === 'preview') {
      this.$router.push({
        path: dealRouterPath('/' + activityType + '/edit', source)
      });
      window.scrollBy(0, 1);
    }
  }

  handleSave() {
    const errMsg = validForm();
    if (errMsg) {
      Vue.$toast.error(errMsg);
      return;
    }
    if (window.hasValidated && !window.hasShowModal) {
      window.hasShowModal = true;
      return;
    }
    if (this.templateType === 'groupType' && this.courseType === 'MANY' && this.courseGroupList.length === 1) {
      Vue.$confirm({
        text: `<p >您当前设置为"多课程模式"，若仅设置一个课程拼团方案，请改为"单课程模式"</p>`,
        okText: '单课程模式',
        ok: () => {
          this.changeSectionCourseType('ONE');
          this.handleConfirm();
        },
        cancleText: '去添加课程',
        cancle: () => {
          this.$emit('cancle');
          // 滚动到按钮处
          const parent: any = document.querySelector(`#app`);
          const child: any = document.querySelector(`.pay-edit`);
          parent.scrollTo({
            top: child.offsetTop - 100, //需要父元素设置postion(relative、absolute、fixed)
            behavior: 'smooth'
          });
        },
        cancelType: true // 取消按钮特殊样式
      });
    } else {
      this.handleConfirm();
    }
  }
  handleConfirm() {
    if (this.canPay && this.templateType !== 'distributeGroupType') {
      switch (this.templateType) {
        case 'distributeType': {
          this.handleSaveOk();
          break;
        }
        case 'lessonType': {
          Vue.$confirm({
            text: `<p>您设定的<span style="color: ${HIGHLIGHT_COLOR}">支付${this.payType}</span>为<span style="color: ${HIGHLIGHT_COLOR}">${
              this.payNumber
            }</span>元</p>
            <p style="text-align: center">短信验证功能：<span style="color:  ${HIGHLIGHT_COLOR}">${this.hasOpenSMSVerify ? '开启' : '关闭'}</span></p><br/>
            <p>请核对是否正确？ <br />（注：活动发布后，不可修改！）</p>`,
            okText: '确定',
            ok: () => {
              this.handleSaveOk();
            },
            cancle: () => {
              this.$emit('cancle');
            }
          });
          break;
        }
        case 'bargainType': {
          const storeState: State = this.$store.state;
          const { minPrice, maxPrice } = storeState.bargainParameter;
          Vue.$confirm({
            text: `<p>您开启了砍价支付功能</p>
            <p>日常价：<span style="color: ${HIGHLIGHT_COLOR}">${maxPrice}</span>元 </p>
            <p>底价：<span style="color: ${HIGHLIGHT_COLOR}">${minPrice}</span>元 </p>
            <p style="text-align: center">短信验证功能：<span style="color:  ${HIGHLIGHT_COLOR}">${this.hasOpenSMSVerify ? '开启' : '关闭'}</span></p>
            <p>从日常价到底价一共需砍<span style="color: ${HIGHLIGHT_COLOR}">${storeState.count}</span>次 </p>
            <p>${this.mustMinPay ? `开启<span style="color: ${HIGHLIGHT_COLOR}">底价支付</span>：家长必须砍到底价才能支付购买<br />` : ''} </p><br/>
            <p>请核对是否正确？ <br />（注：活动发布后，不可修改！）</p>`,
            okText: '确定',
            ok: () => {
              this.handleSaveOk();
            },
            cancle: () => {
              this.$emit('cancle');
            }
          });
          break;
        }
        case 'groupType': {
          // 团购
          const storeState: State = this.$store.state;
          const { courseGroupList, courseType } = storeState.section;
          const { payType, payNumber } = storeState;
          Vue.$confirm({
            text: `<p style="text-align: center">您设定的支付模式为<span style="color: ${HIGHLIGHT_COLOR}">${payType}</span></p>
            <p style="text-align: center, color: #888">
            ${payType === '定金' ? ' (预支付：家长按定金金额支付，再通过线下补齐拼团价差额)' : ' (拼团价：家长直接按拼团价金额支付，无需再额外支付费用)'}
            </p>
            ${
              payType === '定金'
                ? `<p style="text-align: center">${payType}金额：<span style="color: ${HIGHLIGHT_COLOR}">${payNumber}</span>元</p>`
                : `${
                    courseType === 'ONE'
                      ? `<p style="text-align: center">${payType}金额：<span style="color: ${HIGHLIGHT_COLOR}">${courseGroupList[0].ladderGroupList[0].groupPrice}</span>元</p>`
                      : ''
                  }`
            }
            <p style="text-align: center">短信验证功能：<span style="color:  ${HIGHLIGHT_COLOR}">${this.hasOpenSMSVerify ? '开启' : '关闭'}</span></p><br/>
            <p>请核对是否正确？ <br />（注：活动发布后，不可修改！）</p>`,
            okText: '确定',
            ok: () => {
              this.handleSaveOk();
            },
            cancle: () => {}
          });
          break;
        }

        case 'solitaireType': {
          const storeState: State = this.$store.state;
          const { payNumber } = storeState;
          // 虚拟接龙功能暂时不可用
          // <p style="text-align: center"> 虚拟接龙状态：<span style="color:  ${HIGHLIGHT_COLOR}">${this.virtualGroup ? '开启' : '关闭'}</span></p>
          Vue.$confirm({
            text: `<p style="text-align: center">定金金额：<span style="color:  ${HIGHLIGHT_COLOR}">${payNumber}</span>元</p>
            <p style="text-align: center">短信验证功能：<span style="color:  ${HIGHLIGHT_COLOR}">${this.hasOpenSMSVerify ? '开启' : '关闭'}</span></p><br/>
            <p>请核对是否正确？ <br />（注：活动发布后，不可修改！）</p>`,
            okText: '确定',
            ok: () => {
              this.handleSaveOk();
            },
            cancle: () => {
              this.$emit('cancle');
            }
          });
          break;
        }
        default:
          break;
      }
    } else if (this.templateType === 'distributeGroupType') {
      this.handleSaveOk();
    } else {
      Vue.$confirm({
        text: `<p style="text-align: center">短信验证功能：<span style="color:  ${HIGHLIGHT_COLOR}">${this.hasOpenSMSVerify ? '开启' : '关闭'}</span></p>${
          window.__wxjs_environment === 'miniprogram' ? '确认发布吗' : '确认保存吗'
        }`,
        okText: '确定',
        ok: () => {
          this.handleSaveOk();
        },
        cancle: () => {
          this.$emit('cancle');
        }
      });
    }
  }
  showMaterialModal() {
    this.showMaterial = true;
  }

  showDistributeConfirmModal() {
    const errMsg = validForm();
    if (errMsg) {
      Vue.$toast.error(errMsg);
      return;
    }
    if (this.templateType === 'distributeType') {
      this.showConfirmModal = true;
    } else if (this.templateType === 'distributeGroupType') {
      if (this.courseType === 'MANY' && this.courseGroupList.length === 1) {
        Vue.$confirm({
          text: `<p >您当前设置为"多课程模式"，若仅设置一个课程拼团方案，请改为"单课程模式"</p>`,
          okText: '单课程模式',
          ok: () => {
            this.changeSectionCourseType('ONE');
            this.showDistriubteGroupConfirmModal = true;
          },
          cancleText: '去添加课程',
          cancle: () => {
            this.$emit('cancle');
            // 滚动到按钮处
            const parent: any = document.querySelector(`#app`);
            const child: any = document.querySelector(`.pay-edit`);
            parent.scrollTo({
              top: child.offsetTop - 100, //需要父元素设置postion(relative、absolute、fixed)
              behavior: 'smooth'
            });
          },
          cancelType: true // 取消按钮特殊样式
        });
      } else {
        this.showDistriubteGroupConfirmModal = true;
      }
    }
  }
  // 一键复制
  handleToCopy() {
    // 发送复制请求
    const data = this.getMaterialData();
    const adminId: string = getUrlParam('adminId') as string;
    fetch.Sales('anon/businessShow/saveMaterial', data).then((res: AxiosPromiseData) => {
      // 没有复制成功就不跳转页面
      const { success } = res;
      if (success) {
        Vue.$toast.success('保存成功');
        if (isXiaomaiApp()) {
          appSuccess(this.currentId);
        } else {
          const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || 'dev';
          let url = '';
          if (env === 'prod') {
            url = 'https://res.xiaomai5.com/xmshow/index2.html#/';
          } else {
            url = (CONFIG.showUrl as any)[env];
          }
          if (this.type === 'reEdit') {
            window.location.replace(url + 'reEditSuccess');
          } else {
            window.location.replace(url + 'success');
          }
          parent.postMessage(
            {
              value: this.currentId,
              action: 'saveActivity'
            },
            '*'
          );
        }
      }
    });
  }

  handleHiddenMaterailModal() {
    this.showMaterial = false;
    this.handleRedirectSuccPage(this.currentId);
  }

  // 隐藏分销类型的确认框
  handleHiddenConfirmModal() {
    this.showConfirmModal = false;
    this.showDistriubteGroupConfirmModal = false;
  }

  // 扭蛋机获取prizes参数
  getParamsPrize() {
    const storeState: State = this.$store.state;
    const { gachaTypeParameter } = storeState;
    let { proList, addNum } = gachaTypeParameter.prize;
    let prizes = [];
    prizes = proList.map((item: any, index: number) => {
      let { winningProbability, description, name, img, num, id } = item;

      return id
        ? {
            id,
            chanceOfWin: winningProbability,
            description,
            name,
            order: index,
            total: num,
            url: img
          }
        : {
            chanceOfWin: winningProbability,
            description,
            name,
            order: index,
            total: num,
            url: img
          };
    });
    return { prizes };
  }

  getParamAndContent() {
    if (this.templateType === 'bargainType') {
      return this.getBargainParamAndContent();
    }
    if (this.templateType === 'tyType') {
      return this.getTyParamAndContent();
    }
    if (this.templateType === 'lessonType') {
      return this.getLessonParamAndContent();
    }
    // 团购
    if (this.templateType === 'groupType') {
      return this.getGroupParamAndContent();
    }
    if (this.templateType === 'solitaireType') {
      return this.getSolitaireParamAndContent();
    }
    if (this.templateType === 'gachaType') {
      return this.getGachaParamAndContent();
    }
    // 分销
    if (this.templateType === 'distributeType') {
      return this.getDistributeParamAndContent();
    }
    // 超级团购
    if (this.templateType === 'distributeGroupType') {
      return this.getDistributeGroupParamAndContent();
    }
  }

  getDistributeParamAndContent(): { parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      documentTitle,
      distributeTypeParameter,
      contactQrcode,
      signupItemConfig,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      groupImageList,
      needLimitNormalStu,
      hasOpenSMSVerify,
      instAddress
    } = storeState;
    const { limitBuyerNum, courseOriginPrice, courseRushPrice, courseName } = section;
    const { distributeMode, hasOpenSecondDistribute, firstReward, secondReward } = distributeTypeParameter;

    // 单位由元转成分
    const fristRewardToCent = Number((Number(firstReward) * 100).toFixed(2));
    const secondRewardToCent = Number((Number(secondReward) * 100).toFixed(2));
    const courseOriginPriceToCent = Number((Number(courseOriginPrice) * 100).toFixed(2));
    const courseRushPriceToCent = Number((Number(courseRushPrice) * 100).toFixed(2));

    let parameter = {
      payLimitNumber: limitBuyerNum, // 购课人数限制
      originalPrice: courseOriginPriceToCent, // 课程日常价
      price: courseRushPriceToCent, // 抢购价
      distributeMode: distributeMode, // 分销模式
      enableLevelTwo: hasOpenSecondDistribute, // 是否开启二级分销， 开启true
      levelOneBonus: fristRewardToCent, // 一级分销佣金
      levelTwoBonus: secondRewardToCent, // 二级分销佣金
      needLimitNormalStu: needLimitNormalStu,
      needAuthCode: hasOpenSMSVerify // 是否开启短信验证，开启为true
    };
    const content = {
      documentTitle,
      courseName,
      instAddress,
      distributeTypeParameter,
      contactQrcode,
      signupItemConfig,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      groupImageList,
      limitBuyerNum,
      courseOriginPrice: courseOriginPriceToCent,
      courseRushPrice: courseRushPriceToCent
    };

    return {
      parameter,
      content
    };
  }
  getGachaParamAndContent(): { parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      documentTitle,
      gachaTypeParameter,
      contactQrcode,
      signupItemConfig,
      showBarrage,
      showNum,
      showData,
      // viewBackground,
      groupImageList,
      needLimitNormalStu,
      hasOpenSMSVerify
    } = storeState;
    let parameter = {};
    // 扭蛋机——抽奖学金
    if (gachaTypeParameter.gachaType === 'scholarship') {
      let { highest, least, most } = gachaTypeParameter.scholarship;
      let { totalTimes, dayTimes } = section;
      let { dayTimesChecked, totalTimesChecked } = gachaTypeParameter;
      parameter = {
        needLimitNormalStu,
        ceilingOfScholarship: highest,
        kind: 1,
        limitKind: dayTimesChecked ? 1 : 2,
        limitNumber: dayTimesChecked ? dayTimes : totalTimes,
        oneRoundMax: most,
        oneRoundMin: least,
        needAuthCode: hasOpenSMSVerify
      };
      // 扭蛋机——抽奖品
    } else {
      let { totalTimes, dayTimes } = section;
      let { dayTimesChecked, totalTimesChecked } = gachaTypeParameter;
      parameter = {
        needLimitNormalStu,
        kind: 2,
        limitKind: dayTimesChecked ? 1 : 2,
        limitNumber: dayTimesChecked ? dayTimes : totalTimes,
        needAuthCode: hasOpenSMSVerify
      };
    }
    // 两个活动的海报图
    const viewBackground = gachaTypeParameter.gachaType === 'scholarship' ? gachaTypeParameter.scholarship.posterImage : gachaTypeParameter.prize.posterImage;

    const content = {
      documentTitle,
      gachaTypeParameter,
      contactQrcode,
      signupItemConfig,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      groupImageList
    };

    return {
      parameter,
      content
    };
  }

  getSolitaireParamAndContent(): { parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      showBarrage,
      showNum,
      showData,
      documentTitle,
      contactQrcode,
      groupImageList,
      viewBackground,
      signupItemConfig,
      solitaireList,
      limitNum,
      hasOpenSMSVerify,
      needLimitNormalStu
    } = storeState;
    const { personNumber, courseIntros, courseName } = section;
    const sizeList = solitaireList.map(item => item.size);
    const parameter = {
      limitNum,
      sizeList,
      needLimitNormalStu,
      needAuthCode: hasOpenSMSVerify,
      needPay: this.canPay,
      virtualGroup: this.virtualGroup,
      payAmount: formatMoney(this.payNumber, 100)
    };

    const content = {
      courseIntros,
      courseName,
      showBarrage,
      showNum,
      showData,
      documentTitle,
      contactQrcode,
      viewBackground,
      groupImageList,
      signupItemConfig,
      solitaireList,
      payType: this.payType
    };
    if (this.canPay && this.type === 'edit') {
      window.TDAPP.onEvent('支付模式', '群接龙', { 方式: '定金' });
    }
    return {
      parameter,
      content
    };
  }
  getBargainParamAndContent(): { parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      bargainParameter,
      chooseDegree,
      documentTitle,
      signupItemConfig,
      groupImageList,
      contactQrcode,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      hasOpenSMSVerify,
      needLimitNormalStu
    } = storeState;
    const { prizeName, prizePic, prizeDesc, prizeIntros } = section;
    const { prizeNum, minPrice, maxPrice, minCutPrice, maxCutPrice, intervalTime } = bargainParameter;
    const parameter = {
      prizeNum,
      needLimitNormalStu,
      needAuthCode: hasOpenSMSVerify,
      needPay: this.canPay,
      minPrice: formatMoney(minPrice, 100),
      maxPrice: formatMoney(maxPrice, 100),
      minCutPrice: formatMoney(minCutPrice, 100),
      maxCutPrice: formatMoney(maxCutPrice, 100),
      intervalTime: Math.round(intervalTime * 60)
    };
    if (this.canPay) {
      (parameter as any).mustMinPay = this.mustMinPay;
    }
    const content = {
      prizeName,
      // prizePic,
      // prizeDesc,
      prizeIntros,
      chooseDegree,
      documentTitle,
      signupItemConfig,
      groupImageList,
      contactQrcode,
      showBarrage,
      showNum,
      showData,
      viewBackground
    };
    if (this.canPay && this.type === 'edit') {
      if (this.mustMinPay) {
        window.TDAPP.onEvent('支付模式', '砍价', { 方式: '底价支付' });
      } else {
        window.TDAPP.onEvent('支付模式', '砍价', { 方式: '过程支付' });
      }
    }
    return {
      parameter,
      content
    };
  }
  getTyParamAndContent() {
    const storeState: State = this.$store.state;
    const {
      section,
      tyTypeParameter,
      groupImageList,
      chooseDegree,
      contactQrcode,
      signupItemConfig,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      documentTitle,
      hasOpenSMSVerify,
      needLimitNormalStu
    } = storeState;
    const { prizeName, prizeDesc, prizeIntros, prizePic } = section;
    const { prizeNum, intervalTime, unitNum, goodValue, normalValue, badValue } = tyTypeParameter;
    const parameter = {
      prizeNum,
      unitNum,
      goodValue,
      normalValue,
      badValue,
      needLimitNormalStu,
      needAuthCode: hasOpenSMSVerify,
      unitTitle: this.titleSection.getPrizesNoun,
      unitStr: this.titleSection.getPrizesUnit,
      vebStr: this.titleSection.getPrizesVerb,
      intervalTime: Math.round(intervalTime * 60)
    };
    const content = {
      groupImageList,
      prizeName,
      // prizePic,
      // prizeDesc,
      prizeIntros,
      chooseDegree,
      contactQrcode,
      signupItemConfig,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      documentTitle
    };
    return {
      parameter,
      content
    };
  }
  getLessonParamAndContent() {
    const storeState: State = this.$store.state;
    const {
      documentTitle,
      signupItemConfig,
      groupImageList,
      contactQrcode,
      showBarrage,
      showNum,
      showData,
      viewBackground,
      hasOpenSMSVerify,
      needLimitNormalStu
    } = storeState;
    const parameter = {
      needLimitNormalStu,
      needAuthCode: hasOpenSMSVerify,
      isLimited: this.isLimited,
      needPay: this.canPay
    };
    if (this.isLimited) {
      (parameter as any).limitNum = this.limitNum;
    }
    if (this.canPay) {
      (parameter as any).payAmount = Number((Number(this.payNumber) * 100).toFixed(0));
    }

    const content = {
      payType: this.payType,
      documentTitle,
      signupItemConfig,
      groupImageList,
      contactQrcode,
      showBarrage,
      showNum,
      showData,
      viewBackground
    };
    if (this.canPay && this.type === 'edit') {
      if (this.payType === '定金') {
        window.TDAPP.onEvent('支付模式', '微传单', { 方式: '定金' });
      } else {
        window.TDAPP.onEvent('支付模式', '微传单', { 方式: '全额' });
      }
    }

    return {
      parameter,
      content
    };
  }
  // 团购
  getGroupParamAndContent(): { parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      headReward,
      showBarrage,
      showNum,
      showData,
      documentTitle,
      contactQrcode,
      groupImageList,
      viewBackground,
      // ladderGroupList,
      signupItemConfig,
      hasOpenSMSVerify,
      groupSwitch,
      unGroupSwitch,
      autoCancel
    } = storeState;
    const { originPrice, groupNumber, courseName, courseType, courseGroupList } = section;
    let _groupPlansParams: any = [];
    for (let i = 0; i < courseGroupList.length; i++) {
      const groupSizeList = courseGroupList[i].ladderGroupList.map(item => item.groupSize);
      const groupSize = courseGroupList[i].ladderGroupList[0].groupSize;
      const currentPrice = courseGroupList[i].ladderGroupList[0].groupPrice;
      if (courseGroupList[i].type === 'new') {
        delete courseGroupList[i].type;
      }
      let item = {
        seqNo: courseGroupList[i].seqNo, // 课程方案序列号
        minPrice: formatMoney(Number(currentPrice), 100), // 原价拼团价
        maxPrice: formatMoney(courseGroupList[i].originPrice, 100), // 原价
        groupSize,
        groupSizeList,
        courseName: courseGroupList[i].courseName
      };
      _groupPlansParams.push(item);
    }
    const parameter = {
      needAuthCode: hasOpenSMSVerify,
      needPay: this.canPay, // 是否开启支付功能
      virtualGroup: this.virtualGroup,
      groupNum: groupNumber, // 支付上限人数
      participantType: groupSwitch, // 老生只能开团不能参团开关
      unGroupSwitch, // 是否显示未成团列表
      autoCancel, // 拼团失败自动取消报名
      groupPlansParams: _groupPlansParams
    };

    if (this.canPay && storeState.payType === '定金') {
      (parameter as any).payAmount = formatMoney(this.payNumber, 100);
    }
    console.log(this.canPay, storeState.payType, storeState.courseType);

    if (this.canPay && storeState.payType === '拼团价' && _groupPlansParams.length === 1) {
      (parameter as any).payAmount = _groupPlansParams[0].minPrice;
    }
    if (_groupPlansParams.length === 1) {
      (parameter as any).groupSize = _groupPlansParams[0].groupSize;
      (parameter as any).groupSizeList = _groupPlansParams[0].groupSizeList;
      (parameter as any).minPrice = _groupPlansParams[0].minPrice;
      (parameter as any).maxPrice = _groupPlansParams[0].maxPrice;
    }

    const content = {
      headReward,
      courseName,
      courseType,
      courseGroupList,
      showBarrage,
      showNum,
      showData,
      documentTitle,
      contactQrcode,
      viewBackground,
      groupImageList,
      signupItemConfig,
      payType: this.payType
    };
    if (this.canPay && this.type === 'edit') {
      if (this.payType === '定金') {
        window.TDAPP.onEvent('支付模式', '拼团', { 方式: '定金' });
      } else {
        window.TDAPP.onEvent('支付模式', '拼团', { 方式: '拼团价' });
      }
    }
    return {
      parameter,
      content
    };
  }

  // 超级团购
  getDistributeGroupParamAndContent(): { parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      headReward,
      showBarrage,
      showNum,
      showData,
      documentTitle,
      contactQrcode,
      groupImageList,
      viewBackground,
      // ladderGroupList,
      signupItemConfig,
      hasOpenSMSVerify,
      groupSwitch,
      unGroupSwitch,
      autoCancel
    } = storeState;

    const { groupNumber, courseName, courseType, courseGroupList, distributeGroupMode,hasCheckUserAgreement } = section;

    let _groupPlansParams: any = [];
    for (let i = 0; i < courseGroupList.length; i++) {
      const groupSizeList = courseGroupList[i].ladderGroupList.map(item => item.groupSize);
      const groupSize = courseGroupList[i].ladderGroupList[0].groupSize;
      const currentPrice = courseGroupList[i].ladderGroupList[0].groupPrice;
      if (courseGroupList[i].type === 'new') {
        delete courseGroupList[i].type;
      }
      // 单位由元转成分
      const fristRewardToCent = Number((Number(courseGroupList[i].firstReward) * 100).toFixed(2));
      const secondRewardToCent = Number((Number(courseGroupList[i].secondReward) * 100).toFixed(2));
      let item = {
        seqNo: courseGroupList[i].seqNo, // 课程方案序列号
        minPrice: formatMoney(Number(currentPrice), 100), // 原价拼团价
        maxPrice: formatMoney(courseGroupList[i].originPrice, 100), // 原价
        groupSize,
        groupSizeList,
        courseName: courseGroupList[i].courseName,
        enableLevelTwo: courseGroupList[i].hasOpenSecondDistribute,
        levelOneBonus: fristRewardToCent,
        levelTwoBonus: secondRewardToCent
      };
      _groupPlansParams.push(item);
    }
    const parameter = {
      needAuthCode: hasOpenSMSVerify,
      needPay: true, 
      virtualGroup: this.virtualGroup,
      groupNum: groupNumber, // 支付上限人数
      participantType: groupSwitch, // 老生只能开团不能参团开关
      unGroupSwitch, // 是否显示未成团列表
      autoCancel, // 拼团失败自动取消报名
      groupPlansParams: _groupPlansParams
    };

    if ( storeState.payType === '定金') {
      (parameter as any).payAmount = formatMoney(this.payNumber, 100);
    }
    if (storeState.payType === '拼团价' && _groupPlansParams.length === 1) {
      (parameter as any).payAmount = _groupPlansParams[0].minPrice;
    }
    if (_groupPlansParams.length === 1) {
      (parameter as any).groupSize = _groupPlansParams[0].groupSize;
      (parameter as any).groupSizeList = _groupPlansParams[0].groupSizeList;
      (parameter as any).minPrice = _groupPlansParams[0].minPrice;
      (parameter as any).maxPrice = _groupPlansParams[0].maxPrice;
    }

    const content = {
      headReward,
      courseName,
      courseType,
      courseGroupList,
      showBarrage,
      showNum,
      showData,
      documentTitle,
      contactQrcode,
      viewBackground,
      groupImageList,
      signupItemConfig,
      payType: this.payType,
      distributeGroupMode,
      hasCheckUserAgreement
    };
    if ( this.type === 'edit') {
      if (this.payType === '定金') {
        window.TDAPP.onEvent('支付模式', '拼团', { 方式: '定金' });
      } else {
        window.TDAPP.onEvent('支付模式', '拼团', { 方式: '拼团价' });
      }
    }
    return {
      parameter,
      content
    };
  }
  getMaterialData() {
    const storeState: State = this.$store.state;
    const { instName, groupImageList, contactQrcode } = storeState;
    const { content }: any = this.getParamAndContent();
    const { instPhone, contactInfo, institutionIntros } = content;
    const carousel = groupImageList.filter(img => {
      return img;
    });
    const contact = {
      contact: this.contactInfo,
      qrcode: contactQrcode
    };
    const data = {
      instName,
      instId: getUrlParam('instId') || this.instId,
      instPhone: this.instPhone,
      carousel: JSON.stringify(carousel),
      contact: JSON.stringify(contact),
      introduction: JSON.stringify(this.institutionIntros)
    };
    return data;
  }

  getFormData() {
    const storeState: State = this.$store.state;
    const instId: string = getUrlParam('instId') as string;
    const orgId: string = getUrlParam('orgId') as string;
    const creatorId: string = getUrlParam('aid') as string;
    const adminId: string = getUrlParam('adminId') as string;
    const activityType: string = getUrlParam('id') as string;
    const broadcastId: string = getUrlParam('broadcastId') as string;
    const instIds: any = this.instIds;
    const title: string = this.title;
    const deadline: number = Number(this.deadline);
    const startTime: number = Number(this.startTime);
    const { instName } = storeState;
    const { parameter, content }: any = this.getParamAndContent();
    const { prizes }: any = this.getParamsPrize();
    let cover = content.viewBackground ? content.viewBackground : content.groupImageList[0];
    // 去掉oss后缀
    if (!content.viewBackground && cover.includes('?')) {
      cover = cover.slice(0, cover.indexOf('?'));
    }
    content.selectedBGM = this.selectedBGM;
    content.instPhone = this.instPhone;

    content.activityTitle = this.activityTitle;
    content.activityIntros = this.activityIntros;
    content.activitySwitch = this.activitySwitch;

    content.contactTitle = this.contactTitle;
    content.contactSwitch = this.contactSwitch;
    content.contactInfo = this.contactInfo;

    content.institutionIntros = this.institutionIntros;
    content.institutionSwitch = this.institutionSwitch;
    content.institutionTitle = this.institutionTitle;

    content.xmMajordomo = storeState.xmMajordomo;

    let _activityType = activityType;
    if (activityType.search('%3F') > -1) {
      _activityType = activityType.slice(0, activityType.search('%3F'));
    }

    const data = {
      title,
      instName,
      deadline,
      startTime,
      activityType: _activityType,
      content: JSON.stringify(content),
      parameter: JSON.stringify(parameter),
      cover: cover
    };

    if (Object.keys(prizes).length !== 0 && getActivityType() === 'gachaType' && this.$store.state.gachaTypeParameter.gachaType === 'prize') {
      (data as any).prizes = prizes;
    }
    if (startTime) {
      (data as any).startTime = startTime;
    }
    if (broadcastId) {
      (data as any).broadcastId = broadcastId;
    }
    if (instId) {
      (data as any).instId = instId;
    }
    if (orgId) {
      (data as any).orgId = orgId;
    }
    if (orgId && instIds) {
      (data as any).instIds = instIds.includes('0') ? storeState.instList.filter((item: any) => item && item.hasPay).map((item: any) => item.instId) : instIds;
    }
    if (adminId && adminId !== 'unknown') {
      (data as any).adminId = adminId;
    }
    if (creatorId) {
      (data as any).creatorId = creatorId;
    }
    return data;
  }

  handleSaveOk() {
    const data: any = this.getFormData();
    !data.instId && delete data.instId;
    console.log('保存-data', data);
    console.log('保存-parameter', JSON.parse(data.parameter));
    console.log('保存-content', JSON.parse(data.content));
    if (this.test) {
      return;
    }
    const { activityType } = data;
    const adminId: string = getUrlParam('adminId') as string;
    const broadcastId: string = getUrlParam('broadcastId') as string;

    if (isXiaomaiApp()) {
      window.TDAPP.onEvent('点击【保存活动】', 'APP端编辑', {
        来源: 'APP端编辑'
      });
    } else if (isMobile()) {
      window.TDAPP.onEvent('点击【保存活动】', '扫码编辑', {
        来源: '扫码编辑'
      });
    } else {
      window.TDAPP.onEvent('点击【保存活动】', '电脑端编辑', {
        来源: '电脑端编辑'
      });
    }

    // 小程序环境
    if (adminId) {
      // 除了集赞类型
      if (this.templateType !== 'tyType') {
        const apiUrl: string = getUrlParam('broadcastId') && getUrlParam('state') != 'copy' ? 'anon/show/saveActivity' : 'anon/show/createAndReleaseActivity';
        (data as any).templateId = activityType;
        (data as any).activityId = broadcastId;
        fetch.newpost(apiUrl, data).then((res: AxiosPromiseData) => {
          Vue.$toast.success('发布成功');
          if (adminId == 'unknown') {
            //跳转到登录界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/quick-login/main?id=${res.result}`
            });
          } else {
            //跳转到活动发布成功界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/activity/activityShare/main?id=${res.result}`
            });
          }
        });
      } else {
        const apiUrl: string = getUrlParam('broadcastId') && getUrlParam('state') != 'copy' ? 'c/xm/show/save' : 'c/xm/show/addAndRelease';
        fetch.post(apiUrl, data).then((res: AxiosPromiseData) => {
          Vue.$toast.success('发布成功');
          if (adminId == 'unknown') {
            //跳转到登录界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/quick-login/main?id=${res.data}`
            });
          } else {
            //跳转到活动发布成功界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/activity/activityShare/main?id=${res.data}`
            });
          }
        });
      }
    } else {
      if (this.templateType === 'tyType') {
        const apiUrl: string = getUrlParam('broadcastId') && getUrlParam('state') != 'copy' ? 'c/xm/show/save' : 'c/xm/show/add';
        fetch.post(apiUrl, data).then((res: AxiosPromiseData) => {
          this.currentId = res.data;
          const orgId: string = getUrlParam('orgId') as string;
          if (orgId) {
            this.handleRedirectSuccPage(res.data);
            return;
          }
          // 保存成功之后再复制
          const param = { instId: getUrlParam('instId') || this.instId };
          fetch.Sales('anon/businessShow/getMaterial', param).then((materialRes: AxiosPromiseData) => {
            const { result } = materialRes;
            // 判断是否需要复制(临时方案：只能根据返回数据的长度来判断)
            if (Object.keys(result).length <= 2) {
              this.showMaterialModal();
            } else {
              // 不需要复制就直接保存成功
              this.handleRedirectSuccPage(res.data);
            }
          });
        });
      } else {
        (data as any).templateId = activityType;
        (data as any).activityId = broadcastId;
        const apiUrl: string = getUrlParam('broadcastId') && getUrlParam('state') != 'copy' ? 'anon/show/saveActivity' : 'anon/show/createActivity';
        fetch.newpost(apiUrl, data).then((res: AxiosPromiseData) => {
          this.currentId = res.result;
          const orgId: string = getUrlParam('orgId') as string;
          if (orgId) {
            this.handleRedirectSuccPage(res.result);
            return;
          }
          // 保存成功之后再复制
          const param = { instId: getUrlParam('instId') || this.instId };
          fetch.Sales('anon/businessShow/getMaterial', param).then((materialRes: AxiosPromiseData) => {
            const { result } = materialRes;
            const orgId: string = getUrlParam('orgId') as string;
            if (orgId) {
              this.handleRedirectSuccPage(res.result);
              return;
            }
            // 判断是否需要复制
            if (Object.keys(result).length <= 2) {
              this.showMaterialModal();
            } else {
              // 不需要复制就直接保存成功
              this.handleRedirectSuccPage(res.result);
            }
          });
        });
      }
    }
  }

  // 跳转到成功页面
  handleRedirectSuccPage(broadcastId: string) {
    Vue.$toast.success('保存成功');
    if (isXiaomaiApp()) {
      appSuccess(broadcastId);
    } else {
      const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || 'dev';
      let url = '';
      if (env === 'prod') {
        url = 'https://res.xiaomai5.com/xmshow/index2.html#/';
      } else {
        url = (CONFIG.showUrl as any)[env];
      }
      if (this.type === 'reEdit') {
        window.location.replace(url + 'reEditSuccess');
      } else {
        window.location.replace(url + 'success');
      }
      parent.postMessage(
        {
          value: broadcastId,
          action: 'saveActivity'
        },
        '*'
      );
    }
  }
}
